import { PressableStateCallbackType } from 'react-native';

const getPressableOpacityStyles = ({
    pressed,
}: PressableStateCallbackType) => ({ opacity: pressed ? 0.5 : 1 });

export default getPressableOpacityStyles;
